(function() {

  // Footer padding
  function setMainWrapperPadding() {
    var footer = document.querySelector('.footerWrapper');
    if (!footer) return;
    var mainWrapper = document.querySelector('.mainWrapper');
    if (!mainWrapper) return;
    mainWrapper.style.marginBottom = footer.offsetHeight + 'px';
  }
  setMainWrapperPadding();
  window.addEventListener('resize', function() { setMainWrapperPadding(); });

  // Fix: theme-hot-reload.js fires shopify:section:load unconditionally, causing
  // Broadcast's I(document) to register duplicate document-level listeners.
  // Every click opens the filter then immediately closes it.
  //
  // Fix: attach a CAPTURE-phase listener to the filter button.
  // Capture fires before any bubble-phase listener, so stopImmediatePropagation
  // prevents all of theme.js's duplicate handlers from running.
  // We then own the toggle entirely.
  window.addEventListener('load', function() {
    document.querySelectorAll('[aria-controls="filter-groups"]').forEach(function(btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));

      // Sync panel state with button's initial aria-expanded on load
      if (panel) {
        if (btn.getAttribute('aria-expanded') === 'true') {
          panel.classList.add('expanded');
          panel.classList.remove('no-mobile-animation');
        }
      }

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        // Stop ALL further listeners (bubble-phase handlers, document-level handlers)
        e.stopImmediatePropagation();

        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');

        if (panel) {
          if (isOpen) {
            panel.classList.remove('expanded');
          } else {
            panel.classList.add('expanded');
            panel.classList.remove('no-mobile-animation');
          }
          var onStart = function() {
            panel.classList.add('expanding');
            panel.removeEventListener('transitionstart', onStart);
          };
          var onEnd = function() {
            panel.classList.remove('expanding');
            panel.removeEventListener('transitionend', onEnd);
          };
          panel.addEventListener('transitionstart', onStart);
          panel.addEventListener('transitionend', onEnd);
        }
      }, true); // true = capture phase: fires before theme.js bubble-phase listeners
    });
  });

})();
